import { render, staticRenderFns } from "./StudioSettingsGeneral.vue?vue&type=template&id=433e1050&scoped=true"
import script from "./StudioSettingsGeneral.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioSettingsGeneral.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioSettingsGeneral.vue?vue&type=style&index=0&id=433e1050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e1050",
  null
  
)

export default component.exports